import CardSettingOverlay from '../CardSettingOverlay.vue';
import Store from 'Services/Store';
import LocalStorage from '../../../../core/commons/LocalStorage';

const CardMixin = {
    inheritAttrs: false,
    props: {
        data: { type: [Object, Array], required: false },
        name: { type: String },
        settings: { type: [Array, Object] },
        customSettings: { type: [Array, Object] },
        type: { type: String },
        error: { type: String, required: false, default: null },
        timeout: { type: Number, required: false, default: 1 },
    },
    created: function () {
        if (!this.cardData && !this.error) {
            this.fetchCard(this.settings.type);
        }
    },
    data() {
        return {
            cardData: this.data,
            loading: false,
            fiscalYear: this.settings.fiscalYear,
            showSettingsForm: false,
        };
    },
    computed: {
        fiscalDate() {
            if (this.fiscalYear) {
                const date =
                    Store.get('corp').timeformat === 'dmy'
                        ? moment(this.fiscalYear, 'X').format('DD/MM/YYYY')
                        : moment(this.fiscalYear, 'X').format('MM/DD/YYYY');
                return date;
            } else {
                return false;
            }
        },
    },
    methods: {
        fetchCard(card, params = {}, refreshCache = false) {
            const self = this;
            self.loading = true;

            const isCumul = card.startsWith('cumulio');

            // cumulio has an URL like type, so we need to pass it as a query params to avoid erros
            const cardID = isCumul ? `cumulio?type=${card}` : card;

            if (!isCumul) {
                const cacheKey = this.getCacheKey(card, refreshCache);
                params['t'] = cacheKey;
            }

            window.SellsyJS.WebServiceCaller.get(
                `/home/card/${cardID}`,
                params,
                function (result) {
                    self.cardData = result.card.content;
                    self.fiscalYear = result.card.settings.fiscalYear;
                    self.loading = false;
                    window.EventBus.emit(`dashboard-card-${card}:fetched`);
                    self.$emit('fetched', card, result.card);
                },
                function () {
                    Push.error(
                        self.$l10n.__(
                            "Une erreur s'est produite lors de la récupération des données.",
                        ),
                        false,
                    );
                },
            );
        },
        toggleSettingsForm() {
            this.showSettingsForm = !this.showSettingsForm;
        },

        getCacheKey(cardName, refreshCache = false) {
            const localStorage = new LocalStorage('dashboard-cache', cardName);

            if (!refreshCache) {
                const value = localStorage.get();

                if (value) {
                    return value;
                }
            }

            const ts = moment().unix();
            localStorage.set(ts);

            return ts;
        },
    },
    components: {
        'card-setting-overlay': CardSettingOverlay,
    },
};

export default CardMixin;
